import { useCallback, useEffect, useMemo } from 'react';
import { Plane, Vector2Tuple, Vector3 } from 'three';

import { GroupProps, useThree } from '@react-three/fiber';
import { fromPointer } from '@spazious/dollhouse-three';

import { HtmlProps } from '../Html/index.js';

export interface AnnotationDrawControlsProps extends GroupProps {
  onDraw: (poistion: Vector2Tuple) => void;
}

export interface AnnotationTextareaProps extends HtmlProps {
  position: Vector3;
  children: React.ReactNode;
}

const _va = new Vector3();

export const AnnotationDrawControls: React.FC<AnnotationDrawControlsProps> = ({ onDraw }) => {
  const events = useThree(({ events }) => events);
  const pointer = useThree(({ pointer }) => pointer);
  const camera = useThree(({ camera }) => camera);
  const raycaster = useThree(({ raycaster }) => raycaster);
  const plane = useMemo(() => new Plane(camera.up.clone(), 0), [camera.up]);

  const updatePosition = useCallback(
    (target: Vector3) => {
      return fromPointer(raycaster, pointer, plane, camera, target);
    },
    [camera, plane, pointer, raycaster]
  );

  useEffect(() => {
    const handlePointerUp = () => {
      updatePosition(_va);
      onDraw([_va.x, _va.z]);
    };

    events.connected?.addEventListener('pointerup', handlePointerUp);

    return () => {
      events.connected?.removeEventListener('pointerup', handlePointerUp);
    };
  }, [onDraw, events.connected, updatePosition]);

  return null;
};
